import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { SashaBreadcrumbModule } from '../../shared/components/breadcrumb/sasha-breacrumb.module';
import { BookingSearchResultComponent } from './booking-search-result.component';
import { BookingSearchResultRouting } from './booking-search-result.routing';
import { SearchSummaryModule } from 'libraries/component/search-summary/search-summary.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { BookingResultsContainerModule } from './components/booking-results-container/booking-results-container.module';
import { BtnModule } from "libraries/ui_button/btn.module";
import { BookingSummaryService } from './booking-summary.service';
import { DateRangePipeModule } from 'app_sasha/shared/pipes/dateRange/dateRange.module';
import { BookingResourceModule } from 'libraries/service/resources/booking/bookingResource.module';
import { BookingSearchFormModule } from 'app_sasha/shared/components/booking-search-form/booking-search-form.module';
import { DateRangePipe } from 'app_sasha/shared/pipes/dateRange/dateRange.pipe';
import { BookingStatusModule } from 'libraries/component/booking/booking-status/booking-status.module';
import { LabelModule } from 'libraries/service/label/label.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { PaginationModule } from "libraries/component/pagination/pagination.module";
import { PriceRealAmountPipe } from "libraries/pipes/price/priceRealAmount.pipe";


@NgModule({
    imports: [
        CommonModule,
        SashaBreadcrumbModule,
        PaginatorModule, // TODO need to be replace by PaginationModule
        BookingSearchResultRouting,
        BookingResourceModule,
        PermissionModule,
        SearchSummaryModule,
        BookingResultsContainerModule,
        BtnModule,
        DateRangePipeModule,
        BookingSearchFormModule,
        BookingStatusModule,
        LabelModule,
        TitleServiceModule,
        FontAwesomeModule,
        PaginationModule,
    ],
    declarations: [
        BookingSearchResultComponent,
    ],
    providers: [
        BookingSummaryService,
        DateRangePipe,
        PriceRealAmountPipe
    ]
})
export class BookingSearchResultModule { }
